export default "__VITE_ASSET__mLTGrhuR__"